// 热门游戏数据
export const esportsGames = [
    {
      id: 'mc',
      name: '我的世界',
      logo: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/logos/Global-Header_MCCB-Logo_300x51.svg',
      banner: 'https://pic6.zhimg.com/80/v2-acb61183e22a905b4477918d9c727678_1440w.png',
      description: '《我的世界》是一款风靡全球的沙盒建造游戏，由瑞典开发商Mojang Studios开发。玩家可以在一个由方块组成的开放世界中自由探索、采集资源、建造建筑、合成工具，并与生物互动。游戏提供多种模式，包括创造模式（无限资源，专注建造）、生存模式（对抗怪物，管理生命值和饥饿值）以及冒险模式等。凭借极高的自由度和丰富的玩法，《我的世界》成为史上最畅销的游戏之一，并持续吸引着各年龄段的玩家。',
      category: '平台：PC/主机/手机等 | 特色：像素风、无限创造、多人联机',
      qqGroup: 'https://qm.qq.com/q/jqFxBzF8gU',
      url: 'https://mc.ecustvr.top'
    },
    {
      id: 'lol',
      name: '英雄联盟',
      logo: 'https://game.gtimg.cn/images/lol/v3/logo-public.png',
      banner: 'https://game.gtimg.cn/images/lol/lolstrategy/bg-dhjjc.jpg',
      description: '《英雄联盟》（简称“LOL”）是由美国拳头游戏（Riot Games）开发、中国大陆地区腾讯游戏代理运营的英雄对战MOBA竞技网游。游戏里拥有数百个个性英雄，并拥有排位系统、符文系统等特色系统。玩家在游戏中可扮演一个召唤师，每个召唤师拥有一个英雄角色，每个英雄都有自己独特的技能和攻击方式。玩家在游戏中可扮演一个召唤师，每个召唤师拥有一个英雄角色，每个英雄都有自己独特的技能和攻击方式。',
      category: '平台：PC/主机/手机等 | 特色：MOBA、竞技、多人联机',
      qqGroup: 'https://qm.qq.com/q/DhxYVixujS',
    }
    // 可以继续添加其他游戏
  ];
  